import { render, staticRenderFns } from "./ProgramTranscriptTitle.vue?vue&type=template&id=d48d7cac&"
import script from "./ProgramTranscriptTitle.vue?vue&type=script&lang=js&"
export * from "./ProgramTranscriptTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports